import React, { useState, useMemo, useRef, useContext } from "react";
import { DataTableContext } from "../Tabs/Overview";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Popover from "@acadia-ui/popover";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { multipleMasterCampaignsSelected } from "./actionValidations";

export default ({ children }) => {
	const { checkboxSelections } = useContext(DataTableContext);

	const shown = useMemo(() => {
		return checkboxSelections?.selectedMasterCampaigns?.length != 0 || checkboxSelections?.selectedActivationCampaigns?.length != 0 || false;
	}, [checkboxSelections]);

	const disabled = useMemo(() => multipleMasterCampaignsSelected(checkboxSelections), [checkboxSelections]);

	if (shown) {
		return (
			<Popover
				trigger={
					<Tooltip title="Edit" position={TOOLTIP_POSITION.BOTTOM}>
						<Button
							display={BUTTON_DISPLAY.ICON_BORDERED}
							size={BUTTON_SIZE.SMALL}
							icon={"icon-pencil"}
							id="toggleEditMenuButton"
							disabled={disabled}
							data-tracking-id-alt="edit-campaign-button"
						>
							Edit
						</Button>
					</Tooltip>
				}
			>
				<div style={{ display: "flex", flexDirection: "column" }}>{children}</div>
			</Popover>
		);
	}
	return <></>;
};
